import AddPositioningDevicerFittingsModal from './add-positioning-devicer-fittings-modal.vue'
export default AddPositioningDevicerFittingsModal
